import { StartAsPage } from "@/app/[locale]/auth/login/components/types";
import { buildAuthxNavLogistrationUrl } from "@/app/[locale]/auth/login/utils/authxRedirectUtils";
import useAuthxLogistrationSplit from "@/monarch/rules/authxLogistrationSplit/useAuthxLogistrationSplit";
import { useAuthBaseURL } from "./useAuthBaseURL";

interface UseAuthxNavUrlsResult {
  navSignInHref: string;
  navRegisterHref: string;
}

export function useAuthxNavUrls(): UseAuthxNavUrlsResult {
  const authBaseUrl = useAuthBaseURL();
  const signInBaseUrl = new URL("login", authBaseUrl).toString();
  const registerBaseUrl = new URL("register", authBaseUrl).toString();

  const {
    isLoading: loginIsLoading,
    variant: loginVariant,
    data: loginData,
  } = useAuthxLogistrationSplit(StartAsPage.Login);

  const {
    isLoading: registerIsLoading,
    variant: registerVariant,
    data: registerData,
  } = useAuthxLogistrationSplit(StartAsPage.Register);

  return {
    navSignInHref: buildAuthxNavLogistrationUrl({
      baseUrl: signInBaseUrl,
      startAs: StartAsPage.Login,
      authxVariant: loginVariant,
      authxIsLoading: loginIsLoading,
      authxData: loginData,
    }),
    navRegisterHref: buildAuthxNavLogistrationUrl({
      baseUrl: registerBaseUrl,
      startAs: StartAsPage.Register,
      authxVariant: registerVariant,
      authxIsLoading: registerIsLoading,
      authxData: registerData,
    }),
  };
}
